module.exports = __webpack_public_path__ + "static/media/qiniu.54cc9783.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/qiniu.png
// module id = 174
// module chunks = 0